import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import {
  IconFileImport,
  IconX,
  IconCheck,
  IconSparkles,
  IconRefresh,
} from "@tabler/icons-react";
import { toast } from "react-toastify";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";

const C = {
  primary: "#FE6338",
  primarySoft: "#FFF1EC",
  ink: "#141821",
  sub: "#6B7280",
  line: "#ECEEF2",
  panel: "#F7F8FA",
};

function ImportProductsPopupCv({
  show,
  onHide,
  batchNo,
  isKitMode,
  newTotal,
  onImportSuccess,
  rfqid,
}) {
  const { isLoading: importing, postData: importProducts } = usePostRequest(
    API_ENDPOINTS.APPROVE_IMPORT_BATCH,
  );

  const handleConfirm = () => {
    const payload = {
      batch_no: batchNo,
      rfq_id: rfqid,
    };

    importProducts(payload, onSuccessImport, onErrorImport);
  };

  const onSuccessImport = (res) => {
    toast.success(res?.message || "Products imported successfully.");
    onHide();
    onImportSuccess?.(res);
  };

  const onErrorImport = (err) => {
    toast.error(err?.message || "Failed to import products.");
  };

  // OptionCard — add a count badge before the checkbox
  const OptionCard = ({
    checked,
    onToggle,
    icon: Icon,
    title,
    desc,
    accent,
    count,
  }) => (
    <div
      role="button"
      onClick={onToggle}
      className="d-flex align-items-center gap-3 px-3 py-3"
      style={{
        background: "#fff",
        borderRadius: 14,
        cursor: "pointer",
        transition: "all .15s ease",
      }}
    >
      <div className="flex-grow-1">
        <div style={{ fontSize: 14, fontWeight: 600, color: C.ink }}>
          {title}
        </div>
        <div style={{ fontSize: 12.5, color: C.sub }}>{desc}</div>
      </div>
      {typeof count === "number" && (
        <span
          className="px-2"
          style={{
            background: C.primarySoft,
            color: accent,
            borderRadius: 20,
            fontSize: 12.5,
            fontWeight: 700,
            minWidth: 28,
            textAlign: "center",
          }}
        >
          {count}
        </span>
      )}
      <span
        className="d-inline-flex align-items-center justify-content-center"
        style={{
          width: 22,
          height: 22,
          borderRadius: 7,
          border: `1.5px solid ${checked ? accent : "#C7CDD6"}`,
          background: checked ? accent : "#fff",
          flexShrink: 0,
        }}
      >
        {checked && <IconCheck size={14} color="#fff" stroke={3} />}
      </span>
    </div>
  );
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      contentClassName="overflow-hidden"
    >
      <div style={{ borderRadius: 20, overflow: "hidden", background: "#fff" }}>
        {/* Header */}
        <div
          className="d-flex align-items-center justify-content-between px-4"
          style={{ paddingTop: 20, paddingBottom: 16 }}
        >
          <div className="d-flex align-items-center gap-3">
            <span
              className="d-inline-flex align-items-center justify-content-center"
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                background: C.primarySoft,
                color: C.primary,
              }}
            >
              <IconFileImport size={22} stroke={1.9} />
            </span>
            <div>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.ink }}>
                Import Products
              </div>
              <div style={{ fontSize: 13, color: C.sub }}>
                Choose what to include in this import
              </div>
            </div>
          </div>
          <IconX
            size={20}
            role="button"
            onClick={onHide}
            style={{ color: "#98A2B3", cursor: "pointer" }}
          />
        </div>

        <div style={{ height: 1, background: C.line }} />

        {/* Body */}
        {/* Body */}
        <div
          className="px-4"
          style={{ paddingTop: 20, paddingBottom: 8, background: C.panel }}
        >
          {/* <div style={{ fontSize: 13.5, color: C.sub }}>
            {isKitMode
              ? "All kits and their component products will be imported."
              : "All eligible products from this batch will be imported."}
          </div> */}

          <div
            className="px-4"
            style={{ paddingTop: 20, paddingBottom: 8, background: C.panel }}
          >
            <div style={{ fontSize: 13.5, color: C.sub }}>
              All validated products from this batch will be imported. This
              action can't be undone.
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          className="d-flex align-items-center justify-content-end gap-2 px-4"
          style={{ paddingTop: 16, paddingBottom: 18, background: "#fff" }}
        >
          <Button
            onClick={onHide}
            className="fw-semibold"
            style={{
              borderRadius: 12,
              background: "#fff",
              border: `1.5px solid ${C.line}`,
              color: C.sub,
              padding: "9px 22px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={importing}
            className="d-flex align-items-center gap-2 fw-semibold border-0"
            style={{
              borderRadius: 12,
              background: `linear-gradient(135deg, ${C.primary}, #FF7A54)`,
              color: "#fff",
              padding: "9px 22px",
              boxShadow: "0 6px 16px rgba(254,99,56,.35)",
            }}
          >
            {importing ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <>
                <IconCheck size={17} /> Confirm Import
              </>
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ImportProductsPopupCv;
